'use strict'

const SELECTORS = {
    element: '.js-banner',
    slider: '.js-banner-slider',
    playPauseBtn: '.js-banner-slider-play-pause'
};

$(() => {
    $(document).on('click', SELECTORS.playPauseBtn, function (e) {
        e.preventDefault();
        e.stopPropagation();
        if ($(this).hasClass('cc-paused')) {
            $(this).removeClass('cc-paused');
            $(this).closest(SELECTORS.element).find(SELECTORS.slider).slick('slickPlay');
        } else {
            $(this).addClass('cc-paused');
            $(this).closest(SELECTORS.element).find(SELECTORS.slider).slick('slickPause');
        }
    });
});
